import React from "react";
import "./style.scss";

const MatchCompleteIcon = () => (
  <svg
    id="matching-complete-big-icn"
    xmlns="http://www.w3.org/2000/svg"
    width="76"
    height="76">
    <g id="Group_9275" data-name="Group 9275" transform="translate(20 20.865)">
      <g id="gift_1_" data-name="gift (1)">
        <path
          id="Subtraction_4"
          data-name="Subtraction 4"
          className="cls-1"
          d="M23.466 29.809H4.167a2.27 2.27 0 0 1-2.232-2.192v-8.476h30.65v3.228a6.461 6.461 0 0 0-3.075-.777 6.316 6.316 0 0 0-6.365 6.251 6.14 6.14 0 0 0 .321 1.964zM33.627 16.95H1.042A1.01 1.01 0 0 1 0 15.927v-5.26a2.27 2.27 0 0 1 2.232-2.192h2.976a4.047 4.047 0 0 1-.893-2.63A5.906 5.906 0 0 1 10.266 0c2.925 0 4.714 1.592 6.993 4.53C19.539 1.592 21.33 0 24.252 0A5.906 5.906 0 0 1 30.2 5.845a4.975 4.975 0 0 1-.743 2.63h2.826a2.3 2.3 0 0 1 2.381 2.192v5.26a1.009 1.009 0 0 1-1.037 1.023zM24.4 3.216c-1.356 0-2.423.354-5.8 5.26h5.8a2.726 2.726 0 0 0 1.841-.767 2.561 2.561 0 0 0 .837-1.863 2.593 2.593 0 0 0-.778-1.864 2.689 2.689 0 0 0-1.9-.766zm-14.135 0a2.689 2.689 0 0 0-1.9.767 2.612 2.612 0 0 0 0 3.726 2.687 2.687 0 0 0 1.9.767h5.952c-3.517-5.037-4.411-5.26-5.951-5.26z"
        />
      </g>
      <path
        id="check"
        className="cls-1"
        d="m14.544 6.59-7.573 7.573L3.5 10.692l1.233-1.235 2.238 2.232 6.34-6.332z"
        transform="translate(22.698 18.897)"
      />
    </g>
    <path
      id="Subtraction_6"
      data-name="Subtraction 6"
      className="cls-1"
      d="M38 76A38.01 38.01 0 0 1 23.209 2.986 38.01 38.01 0 0 1 52.79 73.014 37.758 37.758 0 0 1 38 76zm0-74.345a36.357 36.357 0 0 0-14.147 69.837 36.356 36.356 0 0 0 28.3-66.981A36.127 36.127 0 0 0 38 1.655z"
    />
  </svg>
);

export default MatchCompleteIcon;
